export enum FilesActionType {
  FETCH_FILES = 'FETCH_FILES',
  FETCH_BULK_FILES = 'FETCH_BULK_FILES',
  FETCH_BRAND_LIST = 'FETCH_BRAND_LIST',
  FETCH_MARKETING_MATERIALS = 'FETCH_MARKETING_MATERIALS',
  FETCH_MATERIALS_SEARCH = 'FETCH_MATERIALS_SEARCH'
}
